import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { changeFavoriteTableSettings } from '../../../redux/ai-studio/aiStudioReducer';
import CommonPagination from '../../../components/common-pagination/CommonPagination';

import scss from './GalleryPagination.module.scss';

function GalleryPagination() {
  const dispatch = useDispatch();
  const { page, size, totalElements } = useSelector((state) => state.aiStudio.favoriteTableSettings);

  const handleChangePage = (newPage) => {
    dispatch(changeFavoriteTableSettings({ page: newPage }));
  };

  return (
    <div className={scss.wrapper}>
      <CommonPagination
        activePage={page}
        totalItemsCount={totalElements}
        itemsPerPage={size}
        onChangePage={handleChangePage}
      />
    </div>
  );
}

export default GalleryPagination;
